import * as React from "react";
import {VeboxTreeView, VeboxTreeViewInputItemProps} from "../VeboxTreeView";
import {getValidChildren, useValue} from "../../../users/HierarchyVisibilityUtils";
import {VeboxSelectionListActionType} from "../../selection_list/VeboxSelectionList";
import {VeboxTreeViewItemProps} from "./VeboxTreeViewItem";

export const VeboxTreeViewRadio: React.FC<VeboxTreeViewInputItemProps & VeboxTreeViewItemProps & React.HTMLAttributes<any>> = ({
                                                                                                                                   value,
                                                                                                                                   parentValue,
                                                                                                                                   onChange,
                                                                                                                                   children,
                                                                                                                                   level,
                                                                                                                                   label,
                                                                                                                                   disabled,
                                                                                                                                   className,
                                                                                                                                   ...rest
                                                                                                                               }) => {

    const currentValue = value;

    const hasChildren = getValidChildren(children).length > 0;
    const isChecked = !hasChildren
        ? Array.isArray(parentValue)
            ? parentValue?.[0] === value
            : parentValue === value
        : Array.isArray(parentValue)
            ? (parentValue ?? [])?.find(v => v === value) !== undefined
            : parentValue === value

    const handleRadioChange = (v, action) => {
        if (action === undefined) {
            if (onChange) {
                if (Array.isArray(v)) {
                    onChange([value, ...v]);
                } else {
                    onChange([value, v]);
                }
            }
        } else {
            switch (action) {
                case VeboxSelectionListActionType.ADD: {
                    const payload = {
                        value,
                        children: [v]
                    }
                    onChange(payload, VeboxSelectionListActionType.ADD);
                    break;
                }
                case VeboxSelectionListActionType.REMOVE: {
                    const payload = {
                        value,
                        children: [...((currentValue.children ?? []).filter(nv => useValue(nv) !== useValue(v)))]
                    }
                    onChange(payload,
                        payload.children.length === 0 ? VeboxSelectionListActionType.REMOVE : VeboxSelectionListActionType.ADD); // Adding is like updating
                    break;
                }
            }
        }
    }

    const handleOnChange = () => {
        if (onChange
        ) {
            onChange(value)
        }
    };


    return (
        <VeboxTreeView.Item
            {...({
                ...rest,
                parentValue: undefined,
                parentState: undefined,
                onChange: undefined,
            })}
            onChange={undefined}
            level={(level ?? 0)}
            className={className + (disabled ? " vebox-tree-view-disabled" : "")}
            label={
                <>
                    {((level ?? 0) >= 1 || value === "all_companies")
                        && <input
                            type={"radio"}
                            value={typeof currentValue === 'object' ? currentValue.value : currentValue}
                            onChange={handleOnChange}
                            checked={isChecked &&
                                !getValidChildren(children)
                                    .some(ch => (parentValue ?? [])
                                        ?.some(v => v === ch.props.value))}
                            disabled={disabled}
                        />}
                    {typeof label === 'function'
                        ? label(isChecked)
                        : label
                    }
                </>
            }
        >
            {React.Children.toArray(children)
                .filter(Boolean)
                .map((c: any) => React.cloneElement(
                    c,
                    {
                        ...c?.props,
                        className: c?.props?.className + className + ((disabled || c?.props?.disabled) ? " vebox-tree-view-disabled" : ""),
                        onChange: c?.props?.onChange ?? handleRadioChange,
                        disabled: disabled || c?.props?.disabled,
                        parentValue: Array.isArray(parentValue)
                            ? (parentValue as any[] ?? []).filter(v => v !== value)
                            : parentValue,
                        level: (level ?? 0) + 1
                    }
                ))
            }
        </VeboxTreeView.Item>
    );

}